import storyInflate from '~/modules/routes/storyInflate'

export default [
  '$rootScope',
  'storyService',
  'metaTemplatesService',
  tabService,
]

const config = [
  {
    condition: () => {
      return window.sessionStorage.getItem('set_tab')
    },
    tab: window.sessionStorage.getItem('set_tab'),
  },
  {
    condition: ({ story, metaTemplatesService }) => {
      // story can be valid and not have an id EL-864
      if (window.org_settings && story._id) {
        const hasErrors = metaTemplatesService
          .requiredForSave(window.org_settings.v2, story)
          .some((o) => o.missing)
        return !hasErrors
      }
      return false
    },
    tab: 'tab-compose',
  },
  // default case goes last
  {
    condition: () => true,
    tab: 'tab-planning',
  },
]

export function tabService($rootScope, storyService, metaTemplatesService) {
  this.tab = null

  // TODO: this seems broke - is it even still needed (for race condition mitigation)?
  this.get = (obj) => {
    // story is not always gauranteed to exist at this point, race condition with initial load
    // if it is undefined, inflate with defaults so it doesnt break meta template service
    let story = obj ? obj.story : storyService.getStorySync()
    story = story || storyInflate({})
    const { tab } = config.find((o) =>
      o.condition({ story, metaTemplatesService })
    )
    this.tab = tab || 'tab-planning'
    return this.tab
  }

  this.getActiveTabId = () => this.tab

  this.set = (tab) => {
    if (typeof tab === 'string') {
      tab = { id: tab }
    }
    if (typeof tab.id === 'string') {
      this.tab = tab.id
    } else if (typeof tab === 'string') {
      this.tab = tab
    } else if (process.env.NODE_ENV === 'testing') {
      return console.warn(
        'error in tab service, tabService.set takes a string or object with id<string> property'
      )
    }
    console.log('broadcasting', tab)
    $rootScope.$broadcast('CHANGE_TAB', { tab })
  }
}
